<template>
    <v-card
        class="mx-auto itemCard pa-3 raceAdvanceSetting"
    >
        <v-row no-gutters v-if="!item">
            <v-col cols="12" md="4" class="mr-1">
                <v-text-field
                    hide-details="auto"
                    :label="$t('page.eventDetails.raceList.race-name')"
                    v-model="raceName"
                    :error-messages="
                        isError.raceName ? $t('page.eventDetails.raceList.is-errors.' + isError.message.raceName) : ''
                        "
                    style="margin: 10px 0"
                    outlined
                    dense
                    @input="sendMessage('raceName')"
                    :placeholder="placeholder.raceName"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters class="ma-0">
            <v-col cols="12" md="5" v-if="mode == 10">
                <v-checkbox
                    v-model="penaltyColumn"
                    :label="$t('page.eventDetails.raceList.penalty-column')"
                    color="primary"
                    hide-details
                ></v-checkbox>
            </v-col>
            <v-col cols="12" md="5" >
                <v-checkbox
                    v-model="showOverall"
                    :label="$t('page.eventDetails.raceList.show-overall')"
                    color="primary"
                    hide-details
                ></v-checkbox>
                <div class="caption title-xs-col">
                  {{ $t("page.eventDetails.raceList.hint-show-overall") }}
                </div>
            </v-col>
            <v-col cols="12" md="5" v-if="mode== 6 || mode== 9">
                <v-checkbox
                    v-model="scoreBased"
                    :label="$t('page.eventDetails.raceList.score-based')"
                    color="primary"
                    hide-details
                ></v-checkbox>
                <div class="caption title-xs-col">
                  {{ $t("page.eventDetails.raceList.hint-score-based") }}
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="mode== 6 || mode== 9">
            <v-col cols="12" md="5">
                <v-checkbox
                    v-model="stopScoring"
                    :label="$t('page.eventDetails.raceList.stop-scoring')"
                    color="primary"
                    hide-details
                ></v-checkbox>
                <div class="caption title-xs-col">
                  {{ $t("page.eventDetails.raceList.hint-stop-scoring") }}
                </div>
            </v-col>
        </v-row>
        <a class="controlOpen" @click="controlOpen" v-if="dropdown">
            <i :class="!open ? 'far fa-chevron-down' : 'far fa-chevron-up'"></i>
        </a>
    </v-card>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";

export default {
    mixins: [ apiCalls ],
    props: { item: Object, dropdown: Boolean },
    data () {
      return {
          open: false,
          raceName: null,
          showOverall: null, 
          penaltyColumn: null,
          scoreBased: null,
          stopScoring: null,
          isError: {
              raceName: false,
              message: {
                  raceName: ""
              }
          },
          mode:6
      };  
    },
    computed: {
        placeholder: function () {
            return {
              raceName: this.$t("page.eventDetails.raceList.placeholder.race-name")
            };
        }
    },
    methods: {
        controlOpen() {
          this.open = !this.open;
        },
    },
    created() {
        if(this.item){
            this.showOverall = this.item.isShowingOverall
            this.scoreBased = this.item.isClassByClass
            this.stopScoring = this.item.stopScoring
            this.penaltyColumn = this.item.penaltyColumn
            this.mode = this.item.mode
        }
    },
}
</script>

<style lang="scss" scoped>
.itemCard {background-color: var(--v-lighten-base) !important;}  
.controlOpen {position: absolute; top: 5px; right: 15px;} 
.raceAdvanceSetting {
    .title-xs-col {
        margin: -6px 0 0 32px;
        text-align: left;
    }
}
</style>